import { useCallback } from 'react';
import { resolveCaseNumber } from '../cloudEvalAdapters';
import EvalReport from './EvalReport';
import { firestoreReportApi } from './reportApi';
import { EVAL_AREAS, scoreCloudEvalCodes } from './reportCodes';

/**
 * Cloud Eval area wrapper. Routes scoring through the cloud scorer only
 * (Normalized chart path / Firestore sd). Shared CMS + generate + history
 * live in EvalReport.
 */
export default function CloudEvalReport({
  client,
  evaluation,
  masterResults,
  normalizedData,
  api = firestoreReportApi,
  claims,
}) {
  const scoreCodes = useCallback(
    (overrides) => scoreCloudEvalCodes({
      client,
      evaluation,
      masterResults,
      normalizedData,
      overrides,
    }),
    [client, evaluation, masterResults, normalizedData]
  );

  return (
    <EvalReport
      api={api}
      area={EVAL_AREAS.CLOUD}
      caseNumber={resolveCaseNumber(evaluation)}
      claims={claims}
      client={client}
      description={(
        <p>
          DA is read from the same Normalized chart rows CloudEvalAnalysis already builds
          (Image vs 1 ± <code className="rounded bg-gray-100 px-1">ctrl-Image-Error</code>, which is Firestore
          <code className="rounded bg-gray-100 px-1">sd</code>). This tab does not reimplement client/avg/sd.
          HS, CS, and D are stubs until scoring rules land — defaults are 0 (None) so template keys can be formed.
        </p>
      )}
      evaluationId={evaluation?.id}
      organizationId={client?.organization_id}
      scoreCodes={scoreCodes}
      title="Cloud Eval Report"
    />
  );
}
